export const sortSelectedSources = <T extends Record<string, unknown>>(
  sources: Array<T>,
  key: keyof T = 'connected'
) => {
  return [...sources].sort((a, b) => {
    if (a[key] && b[key]) return 0;
    if (a[key] && !b[key]) return -1;
    if (!a[key] && b[key]) return 1;
    return 0;
  });
};

export const sortSelectedSourcesFromTwoArrays = <T extends unknown[]>(
  allItems: T,
  selectedItems: T
) => {
  const selectionKeySet = new Set(selectedItems);

  return [...allItems].sort((a, b) => {
    if (!selectedItems) return 1;
    if (selectionKeySet.has(a) && !selectionKeySet.has(b)) return -1;
    if (!selectionKeySet.has(a) && selectionKeySet.has(b)) return 1;
    return 0;
  });
};

export const sortSelectedSourcesFromTwoObjectes = <
  T extends Record<string, unknown>
>(
  allItems: T[],
  selectedItems: T[],
  key: keyof T = 'key'
) => {
  const selectionKeySet = new Set(selectedItems.map((item) => item[key]));

  return [...allItems].sort((a, b) => {
    if (!selectedItems) return 1;
    if (selectionKeySet.has(a[key]) && !selectionKeySet.has(b[key])) return -1;
    if (!selectionKeySet.has(a[key]) && selectionKeySet.has(b[key])) return 1;
    return 0;
  });
};
